import React from 'react';
import { Box } from '@wds/box';
import { createURL } from '@sm/utils';
import { Logo, LogoWithText } from '@sm/webassets';

import useStyles from './useStyles';

const SimpleLogoHeader = (): React.ReactElement => {
  const { header, logo, text, goldie, mobileLogo, desktopLogo } = useStyles();
  return (
    <Box data-testid="SimpleLogoHeader__Container" className={header}>
      <Box mt={6} display="flex" flexJustify="center" className={mobileLogo}>
        <a
          aria-label="SurveyMonkey Home"
          data-testid="SimpleLogoHeader__Goldie"
          href={createURL('/', {})}
          className={goldie}
        >
          <Logo className={text} />
        </a>
      </Box>
      <Box mt={7} ml={7} display="block" className={desktopLogo}>
        <a
          aria-label="SurveyMonkey Home"
          data-testid="SimpleLogoHeader__Logo"
          href={createURL('/', {})}
          className={logo}
        >
          <LogoWithText className={text} />
        </a>
      </Box>
    </Box>
  );
};

export default SimpleLogoHeader;
